/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeStaffEditBasicCtrl
 */
angular.module('mercury.modules.time.staff')
.controller('TimeStaffEditBasicCtrl', ["dialog", "$filter", "$scope", function(dialog, $filter, $scope) {
  $scope.dialog = dialog;
  $scope.updatePosLink = function(posStaffMember) {
    if (posStaffMember) {
      dialog.open({
        templateUrl: 'modules/time/staff/posstaffmemberconfirmdialog.tpl.html',
        scope: $scope
      }).then(function(confirmed) {
        if (confirmed) {
          $scope.applyPosStaffDetails(posStaffMember);
        }
      });
    }
  };
}]);
